var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agile-agreement"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"agreement-content",domProps:{"innerHTML":_vm._s(_vm.info.agreementContent)}})]),_c('div',{staticClass:"agile-agreement-footer"},[_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn agree",on:{"click":_vm.jumpHomePage}},[_vm._v("同意签署")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }